/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { useCallback, useEffect, useState } from "react";
import { Banner } from "@bookingcom/bui-react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useGlobalContext from "../../../hooks/useGlobalContext";
import { setCookie, getCookie } from "../../../utils/cookies";
import Frame from "../Frame";
import useRouteName from "../../../hooks/useRouteName";
import flights_web_flight_card_update_desktop from "../../../utils/experiments/funnel/flights_web_flight_card_update_desktop";
import useProfiler from "../../../hooks/useProfiler";

export default function DSABanner() {
  const routeName = useRouteName();
  const i18n = useI18n();
  const { contentStandardsGuidelines } = useGlobalContext();
  const [visible, setVisibility] = useState(false);
  const { isMobile } = useProfiler();

  const cookieName = routeName === "fly-anywhere" ? "hide_banner_DSA_fa" : "hide_banner_DSA";

  const handleOnClose = useCallback(() => {
    setVisibility(false);
    !isMobile() && flights_web_flight_card_update_desktop.goals.dsa_banner_close();
    try {
      setCookie(cookieName, "1", {
        maxAge: "2h",
        path: "/"
      });
    } catch (error) {} // eslint-disable-line flights/no-empty-catch
  }, [cookieName, isMobile]);

  useEffect(() => {
    try {
      setVisibility(!getCookie(cookieName));
    } catch (error) {} // eslint-disable-line flights/no-empty-catch
  }, [cookieName]);

  const { isDesktop } = useProfiler();

  if (!contentStandardsGuidelines) {
    isDesktop() && flights_web_flight_card_update_desktop.stages.dsa_banner_unavailable();
    return null;
  }
  if (!visible) return null;

  isDesktop() && flights_web_flight_card_update_desktop.stages.users_see_dsa_banner();
  routeName === "fly-anywhere" &&
    isDesktop() &&
    flights_web_flight_card_update_desktop.stages.users_see_dsa_banner_fly_anywhere();

  return (
    <Frame mb={4} attributes={{ "data-testid": "DSABanner" }}>
      <Banner
        dismissible
        closeAriaLabel={i18n.trans(t("close"))}
        text={contentStandardsGuidelines.message}
        onClose={handleOnClose}
        attributes={{ style: { zIndex: 0, position: "relative" } }}
        actions={[
          {
            attributes: { target: "_blank", "data-testid": "DSABanner_link" },
            href: contentStandardsGuidelines.linkUrl,
            text: contentStandardsGuidelines.linkLabel,
            onClick: () => !isMobile() && flights_web_flight_card_update_desktop.goals.dsa_banner_click()
          }
        ]}
      />
    </Frame>
  );
}
